import type { ValueOf } from '@dni-types/utilities/value-of'

export const BUTLER_TAB = {
  FILE: 'file',
  PHOTO: 'photo',
  CSV: 'csv',
} as const

export type ButlerTabType = ValueOf<typeof BUTLER_TAB>

const butlerTabValues: readonly unknown[] = Object.values(BUTLER_TAB)

/** persisted / session 回來的分頁值可能是已移除的舊分頁，寫回 store 前先驗 */
export const isButlerTab = (value: unknown): value is ButlerTabType => butlerTabValues.includes(value)
